// extracted by mini-css-extract-plugin
export default {"sections":"SettingsUI_sections__6UONT"};